import compare from 'comparejs';

var strategiesOperators = (function (op) {
  return {
    range: function range(rowValue, _ref) {
      var start = _ref.start,
          end = _ref.end;
      return start <= rowValue && end >= rowValue;
    },
    equal: function equal(value1, value2) {
      return compare.id(value1, value2);
    },
    greaterThan: compare.gt,
    lessThan: compare.lt,
    contains: function contains(rowValue, value) {
      return String(rowValue).toLowerCase().indexOf(String(value).toLowerCase()) !== -1;
    }
  }[op] || compare.id;
});

export default strategiesOperators;
//# sourceMappingURL=strategiesOperators.js.map
